import React, {useEffect, useRef, useState} from "react";
import {useParams} from "react-router-dom";
function PatTelemedicineRoom() {
    const {id} = useParams();
    const socketRef = useRef(null);
    const pcRef = useRef(null);
    const localVideo = useRef(null);
    const remoteVideo = useRef(null);
    const localStreamRef = useRef(null);
    const remoteChannelRef = useRef(null);
    const myChannelRef = useRef(null);
    const [chatText, setChatText] = useState("");
    const [messages, setMessages] = useState([]);
    const [ready, setReady] = useState(false);
    const userGroup = localStorage.getItem("group") || "";
    const userType = userGroup === "Doctor" ? "doctor" : "patient";
    const userId = localStorage.getItem("user_id");
    // ================= INIT =================
    useEffect(() => {
        start();
        return cleanup;
    }, []);
    const start = async () => {
        await startCamera();
        connectSocket();
    };
    // ================= CAMERA =================
    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true
            });
            localVideo.current.srcObject = stream;
            localStreamRef.current = stream;
            console.log("Camera ready");
        } catch (err) {
            console.log("Camera error:", err);
        }
    };
    // ================= SOCKET =================
    const connectSocket = () => {
        socketRef.current = new WebSocket(
            `wss://demodrghis.mgmebuild.com/ws/telemedicine/${id}/`
        );
        socketRef.current.onopen = () => {
            console.log("WS connected");
            socketRef.current.send(JSON.stringify({
                action: "new-peer",
                peer: userType
            }));
        };
        socketRef.current.onmessage = async (e) => {
            const data = JSON.parse(e.data);
            // ✅ PUT IT HERE
            if (data.action === "peer-ready") {
                remoteChannelRef.current = data.remote;
                console.log("Peer ready:", data.remote);
            }
            switch (data.action) {
                case "new-offer":
                    await handleOffer(data.message);
                    break;
                case "new-answer":
                    await handleAnswer(data.message);
                    break;
                case "new-ice-candidate":
                    await handleIce(data.message);
                    break;
            }
        };
    };
    // ================= PEER =================
    const createPeer = () => {
        if (pcRef.current) return pcRef.current;
        const pc = new RTCPeerConnection({
            iceServers: [
                {urls: "stun:stun.l.google.com:19302"}
            ]
        });
        localStreamRef.current?.getTracks().forEach(track => {
            pc.addTrack(track, localStreamRef.current);
        });
        pc.ontrack = (event) => {
            console.log("Remote stream received");
            remoteVideo.current.srcObject = event.streams[0];
        };
        pc.onicecandidate = (event) => {
            if (event.candidate && remoteChannelRef.current) {
                socketRef.current.send(JSON.stringify({
                    action: "new-ice-candidate",
                    message: {
                        candidate: event.candidate,
                        receiver_channel_name: remoteChannelRef.current
                    }
                }));
            }
        };
        pcRef.current = pc;
        return pc;
    };
    // ================= OFFER =================
    const createOffer = async () => {
        if (!ready) {
            alert("Waiting for patient connection...");
            return;
        }
        if (!remoteChannelRef.current) {
            alert("Waiting for patient to join");
            return;
        }
        const pc = createPeer();
        const offer = await pc.createOffer();
        await pc.setLocalDescription(offer);
        socketRef.current.send(JSON.stringify({
            action: "new-offer",
            message: {
                sdp: offer,
                receiver_channel_name: remoteChannelRef.current
            }
        }));
        console.log("Offer sent");
    };
    // ================= OFFER HANDLER =================
    const handleOffer = async (message) => {
        console.log("Offer received");
        const pc = createPeer();
        await pc.setRemoteDescription(
            new RTCSessionDescription(message.sdp)
        );
        const answer = await pc.createAnswer();
        await pc.setLocalDescription(answer);
        socketRef.current.send(JSON.stringify({
            action: "new-answer",
            message: {
                sdp: answer,
                receiver_channel_name: message.sender_channel_name
            }
        }));
        console.log("Answer sent");
    };
    // ================= ANSWER =================
    const handleAnswer = async (message) => {
        console.log("Answer received");
        await pcRef.current?.setRemoteDescription(
            new RTCSessionDescription(message.sdp)
        );
    };
    // ================= ICE =================
    const handleIce = async (message) => {
        if (!message.candidate) return;
        try {
            await pcRef.current?.addIceCandidate(
                new RTCIceCandidate(message.candidate)
            );
        } catch (err) {
            console.log("ICE error:", err);
        }
    };
    // ================= CHAT =================
    const sendMessage = () => {
        if (!chatText.trim()) return;
        socketRef.current.send(JSON.stringify({
            action: "chat-message",
            appointment_id: id,
            sender_type: userType,
            sender_id: userId,
            message: chatText
        }));
        setChatText("");
    };
    // ================= CLEANUP =================
    const cleanup = () => {
        socketRef.current?.close();
        pcRef.current?.close();
        localStreamRef.current?.getTracks().forEach(t => t.stop());
    };
    return (
        <div className="container mt-3">

            <h4>Telemedicine ({userType})</h4>

            <p>Status: {ready ? "Connected" : "Connecting..."}</p>

            <div className="row">

                <div className="col-md-6">
                    <video ref={localVideo} autoPlay muted playsInline
                           style={{width: "100%", background: "black"}}/>
                </div>

                <div className="col-md-6">
                    <video ref={remoteVideo} autoPlay playsInline
                           style={{width: "100%", background: "black"}}/>
                </div>

            </div>

            {userType === "doctor" && (
                <button className="btn btn-primary mt-3" onClick={createOffer}>
                    Start Call
                </button>
            )}

            <div className="mt-3">

                <div style={{height: 200, overflowY: "auto"}}>
                    {messages.map((m, i) => (
                        <div key={i}>
                            <b>{m.sender_type}</b>: {m.message}
                        </div>
                    ))}
                </div>

                <input
                    className="form-control"
                    value={chatText}
                    onChange={(e) => setChatText(e.target.value)}
                />

                <button className="btn btn-success mt-2" onClick={sendMessage}>
                    Send
                </button>

            </div>

        </div>
    );
}
export default PatTelemedicineRoom;